// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__tkZKK","content":"Error_content__cMme9"};